import './CSS_ke_log/CssForFIVEJS.css';
function Two(){
    return(
 <div className="csskabaap">
    <div class="r"><h3 class="w" id="pncilwala">रक्त प्रकार और कोरोनावायरस के बीच कोई ज्ञात संबंध <span>नहीं</span> है</h3>
  </div>
 </div>
    );
}



export default Two;